
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getCompanySet, modifyCompanySet } from '@/api/system';

@Component({
  name: 'SettingTemplateDiyPamras',
  components: {

  }
})
export default class extends Vue {
  private pamrasSet: any = {
    pamrasBrand: '品牌',
    pamrasProduct: '类型',
    pamrasModel: '型号'
  }
   private auth:any = {
     brand: true
   }
   private showCurrent:number = 1

   private editClick(val: number) {
     this.showCurrent = val;
   }
   created() {
     this.getCompanySet();
   }
   private getCompanySet() {
     let params:any = {};
     params.user_id = UserModule.getUserId;
     params.company_id = UserModule.getCompanyId;
     params.vip_level = (UserModule.company as any).vip_level;
     getCompanySet(params).then(res => {
       if (res.data) {
         if (res.data.companySet) {
           if (res.data.companySet.brand_name_alias) {
             this.pamrasSet.pamrasBrand = res.data.companySet.brand_name_alias;
           }
           if (res.data.companySet.product_name_alias) {
             this.pamrasSet.pamrasProduct = res.data.companySet.product_name_alias;
           }
           if (res.data.companySet.model_name_alias) {
             this.pamrasSet.pamrasModel = res.data.companySet.model_name_alias;
           }
         }
       }
     }).catch((error:any) => {
       let msg = error.msg;
     });
   }
   private setingpamrasPamras() {
     let params:any = {};
     params.user_id = UserModule.getUserId;
     params.company_id = UserModule.getCompanyId;
     params.brand_name_alias = this.pamrasSet.pamrasBrand;
     params.product_name_alias = this.pamrasSet.pamrasProduct;
     params.model_name_alias = this.pamrasSet.pamrasModel;
     this.saveCopanySet(params);
   }
   private saveCopanySet(params:any) {
     modifyCompanySet(params).then(res => {
       this.showSuccessMsg((res as any).msg);
     }).catch(err => {
       this.showErrorMsg(err.msg);
     });
   }
   private showErrorMsg(msg: string) {
     this.$notify({
       title: '提示',
       message: msg,
       offset: 100,
       type: 'error'
     });
   }
   private showSuccessMsg(msg: string) {
     this.$notify({
       title: '提示',
       message: msg,
       offset: 100,
       type: 'success'
     });
   }
}

